import React, { useState, useEffect, useRef } from "react";
import { TableContainer, Paper, Typography, Box } from "@mui/material";
import { api, get, put } from "../../../../utils/api";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import Add from "../Coal/Add";
import View from "../Coal/View";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../../Components/Common/Cards";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import { getMonthName } from "../../../../utils/getMonthName";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import BulkUpload from "./BulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import StatioaryBulkUpload from "../../../../Components/Common/StatioaryBulkUpload";

const NaturalGasEquipment = () => {
  const [selectedDate, setSelectedDate] = useState({});
  const [cardData, setCardData] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Consumption Month": false,
    "Equipment Type": false,
    "Industrial Equipment": false,
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const columnWidth = "12% 21% 19% 18% 21% 8%";
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipmentType: [],
    industrialEquipment: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const [excelData, setExcelData] = useState(null);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    industrialProcess: [],
    equipmentType: [],
    industrialEquipment: [],
    quantityRange: { min: "", max: "" },
    hoursRange: { min: "", max: "" },
  });
  let bannerData = [
    {
      title: "Total Natural Gas Consumed",
      description:
        formatNumberCommaSeparated(truncateNumber(cardData?.total.quantity)) +
        " " +
        cardData?.total.unit,
    },
    {
      title: "Top Equipments By Consumption",
      description: cardData?.topEquipment.map((el) => el.topEquipmentType),
    },
    {
      title: "Consumption Month",
      description:
        formatNumberCommaSeparated(
          truncateNumber(cardData?.monthly?.quantity)
        ) +
          " " +
          cardData?.monthly?.unit || "",
      filter: "date",
      defaultValue: {},
      // key: "wasteManagedByMethod",
      // filterValues: filters?.wasteManagementMethod,
      // defaultValue: cardData?.monthly,
    },
  ];

  const fetchExcelData = async () => {
    await get("/stationaryCombustion/natural-gas/equipment")
      .then((res) => {
        let data = res?.data?.data;
        let data2=res?.data?.uniqueIdObjects;
        let arr =
          data &&
          data?.map((el, idx) => {
            return {
              "Month (in 01/25 or Jan-25)": "",
              Equipment: el?.name,
              "Quantity Consumed (in M3)": "",
              "Calorific Value (in MJ/M3) (optional)": "",
              "Remark (optional)": "",
            };
          });
        let arr2 =
          data2 &&
          data2?.map((el, idx) => {
            return {
              "Month (in 01/25 or Jan-25)": "",
              Equipment: el?.name,
              "Unique ID of Equipment": el?.uniqueID,
              "Quantity Consumed (in M3)": "",
              "Calorific Value (in MJ/M3) (optional)": "",
              "Hours Used": "",
              "Remark (optional)": "",
            };
          });
        
        setExcelData([ { name: "Cumulative Data Entry", data: arr },{ name: "Individual Data Entry", data: arr2  }]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchCardData = async (month, year) => {
    try {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(
        `/stationaryCombustion/naturalGascardData?year=${
          selectedYear ? selectedYear : currentYear
        }&month=${selectedMonth ? selectedMonth : currentMonth + 1}`
      );
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    fetchCardData(year, month, "");
  };

  const filters = [
    "Date",
    "Consumption Month",
    // "Industrial Process",
    "Equipment Type",
    "Industrial Equipment",
    "Quantity Consumed",
    "Hours Used",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    // {
    //   fieldName: "industrialProcess",
    //   title: "Industrial Process",
    //   placeholder: "Select industrial process",
    //   type: "select",
    //   url: `/master/getAllIndustrialProcess`,
    //   field: "industryProcess",
    //   required: true,
    // },
    // {
    //   fieldName: "equipmentType",
    //   title: "Equipment Type",
    //   placeholder: "Select equipment type",
    //   type: "select",
    //   url: `/master/getAllEquipmentType`,
    //   required: true,
    // },
    {
      fieldName: "industrialEquipment",
      title: "Equipment",
      placeholder: "Select industrial equipment",
      type: "select",
      url: `/master/getAllIndustrialEquipment?fuelType=Natural Gas`,
      required: true,
    },
    {
      fieldName: "typeOfEntry",
      title: "Type of Entry",
      placeholder: "Type here",
      type: "select",
      options: ["Cumulative", "Individual"],
      required: true,
    },
    {
      fieldName: "uniqueIdOfEquipment",
      title: "Unique ID of Equipment",
      placeholder: "Select unique id of equipment",
      type: "select",
      required: true,
    },
    {
      fieldName: "quantityConsumed",
      title: "Quantity Consumed",
      placeholder: "Enter quantity",
      type: "number",
      required: true,
      truncate: true,
      // adornmentText: "MT",
      options: ["M3", "Liters", "Gallon", "Tonnes"],
    },
    {
      fieldName: "density",
      title: "Density",
      placeholder: "Enter density",
      type: "number",
      required: true,
    },
    {
      fieldName: "hours",
      title: "Hours Used (optional)",
      placeholder: "Enter hours",
      type: "number",
      condition: true,
    },
    {
      fieldName: "calorificValue",
      title: "Calorific Value (optional)",
      placeholder: 10000,
      type: "number",
      options: ["MJ/kg", "MJ/m3"],
    },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },

    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];
  const bulkuploadInputData = [
    {
      fieldName: "location",
      title: "Location",
      placeholder: "Enter Name",
      type: "text",
    },
    {
      fieldName: "industrialProcess",
      title: "IndustrialProcess",
      placeholder: "Tap to Select",
      type: "select",
      selectUrl: `/master/getAllIndustrialProcess`,
      field: "industryProcess",
      required: true,
    },
    {
      fieldName: "equipmentType",
      title: "Equipment Type",
      placeholder: "Tap to Select",
      type: "select",
      selectUrl: `/master/getAllEquipmentType`,
      field: "name",
      required: true,
    },
    {
      fieldName: "name",
      title: "Equipment Name",
      placeholder: "Enter Name",
      type: "text",
      required: true,
      disabled: true,
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      placeholder: "Enter Fuel Type",
      type: "text",
      required: true,
      disabled: true,
    },
    {
      fieldName: "noOfEquipment",
      title: "No of Equipment",
      placeholder: "Enter No of Equipment",
      type: "number",
      required: true,
    },
  ];
  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/stationaryCombustion/getAllNaturalGas`);
      const data = response.data.data;
      // const uniqueIndustrialProcess = [
      //   ...new Set(
      //     data
      //       .map((el) => el.industrialProcess?.industryProcess)
      //       .filter(Boolean)
      //   ),
      // ];
      const uniqueEquipmentType = [
        ...new Set(data.map((el) => el.equipmentType?.name).filter(Boolean)),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el.industrialEquipment?.name).filter(Boolean)
        ),
      ];

      return {
        // industrialProcess: uniqueIndustrialProcess,
        equipmentType: uniqueEquipmentType,
        industrialEquipment: uniqueIndustrialEquipment,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // useEffect(()=>{
  //   fetchCardData();
  // })

  // fetching Vehicle data
  const fetchData = async (filters = null) => {
    fetchCardData(selectedMonth, selectedMonth);
    try {
      // Use provided filters, or check if filters are applied, or use empty object
      const filtersToUse = filters !== null 
        ? filters 
        : (isFiltersApplied ? getFiltersToApply() : {});
      
      const queryParams = new URLSearchParams({
        ...filtersToUse,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/stationaryCombustion/getAllNaturalGas?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Compute filtersToApply from actual state values to ensure it's always up-to-date
  const getFiltersToApply = () => ({
    startDate: startDate
      ? startDate.format("YYYY-MM-DD")
      : "",
    endDate: endDate
      ? endDate.format("YYYY-MM-DD")
      : "",
    startMonth: startMonth
      ? startMonth.format("YYYY-MM")
      : "",
    endMonth: endMonth
      ? endMonth.format("YYYY-MM")
      : "",
    industrialEquipment: selectedFields?.industrialEquipment || "",
    equipmentType: selectedFields?.equipmentType || "",
    minQuantity: quantityRange?.min || "",
    maxQuantity: quantityRange?.max || "",
    minHours: hoursRange?.min || "",
    maxHours: hoursRange?.max || "",
  });

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Industrial Process": false,
      "Equipment Type": false,
      "Industrial Equipment": false,
      "Quantity Consumed": false,
      "Hours Used": false,
    };

    if (selectedFilter === "Quantity Consumed") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Quantity Consumed"] =
          "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity Consumed"] =
          "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity Consumed"] =
          "Max value should be greater than Min value";
        isValid = false;
      }
    }
    if (selectedFilter === "Hours Used") {
      const min = parseFloat(hoursRange.min);
      const max = parseFloat(hoursRange.max);

      if (min && isNaN(min)) {
        newErrors["Hours Used"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Hours Used"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Hours Used"] = "Max value should be greater than Min value";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      equipmentType: tempFilter?.equipmentType,
      industrialEquipment: tempFilter?.industrialEquipment,
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    setQuantityRange(tempFilter?.quantityRange);
    setHoursRange(tempFilter?.hoursRange);
    
    // Build filters from tempFilter directly to ensure we use the latest values
    const currentFilters = {
      startDate: tempFilter?.startDate
        ? tempFilter?.startDate.format("YYYY-MM-DD")
        : "",
      endDate: tempFilter?.endDate
        ? tempFilter?.endDate.format("YYYY-MM-DD")
        : "",
      startMonth: tempFilter?.startMonth
        ? tempFilter?.startMonth.format("YYYY-MM")
        : "",
      endMonth: tempFilter?.endMonth
        ? tempFilter?.endMonth.format("YYYY-MM")
        : "",
      industrialEquipment: tempFilter?.industrialEquipment || "",
      equipmentType: tempFilter?.equipmentType || "",
      minQuantity: tempFilter?.quantityRange?.min || "",
      maxQuantity: tempFilter?.quantityRange?.max || "",
      minHours: tempFilter?.hoursRange.min || "",
      maxHours: tempFilter?.hoursRange.max || "",
    };
    
    setPage(1);
    setIsFiltersApplied(true);
    fetchData(currentFilters);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      industrialEquipment: "",
      equipmentType: "",
      quantityRange: { min: "", max: "" },
      hoursRange: { min: "", max: "" },
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      equipmentType: [],
      industrialEquipment: [],
    });
    setQuantityRange({ min: "", max: "" });
    setHoursRange({ min: "", max: "" });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isIndustryEquipmentApplied =
      tempFilter?.industrialEquipment?.length > 0;
    const isEquipmentTypeApplied = tempFilter?.equipmentType?.length > 0;
    const isIndustryProcessApplied = tempFilter?.industrialProcess?.length > 0;
    const isQuantityRangeApplied =
      tempFilter?.quantityRange.min || tempFilter?.quantityRange.max;
    const isHoursRangeApplied =
      tempFilter?.hoursRange.min || tempFilter?.hoursRange.max;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isIndustryEquipmentApplied ||
        isEquipmentTypeApplied ||
        isQuantityRangeApplied ||
        isHoursRangeApplied ||
        isIndustryProcessApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isMonthApplied,
      // "Industrial Process": isIndustryProcessApplied,
      "Equipment Type": isEquipmentTypeApplied,
      "Industrial Equipment": isIndustryEquipmentApplied,
      "Quantity Consumed": isQuantityRangeApplied,
      "Hours Used": isHoursRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      industrialEquipment: selectedFields?.industrialEquipment,
      equipmentType: selectedFields?.equipmentType,
      quantityRange: quantityRange,
      hoursRange: hoursRange,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    { title: "Consumption Month", fieldName: "consumptionPeriod" },
    // { fieldName: "industrialProcess", title: "Industrial Process" },
    { fieldName: "industrialEquipment", title: "Equipment" },
    { fieldName: "typeOfEntry", title: "Type of Entry" },
    { fieldName: "quantityConsumed", title: "Quantity Consumed" },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      case "Industrial Process":
        return (
          <MultiSelect
            title="Industrial Process"
            selectedField={selectedFields.industrialProcess}
            selectedFields={selectedFields}
            setSelectedFields={setSelectedFields}
            setErrors={setErrors}
            field="industrialProcess"
            data={uniqueValues.industrialProcess}
          />
        );
      case "Equipment Type":
        return (
          <MultiSelect
            title="Equipment Type"
            url={`${api}/master/getAllEquipmentTypes`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  equipmentType: newValue.equipmentType || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="equipmentType"
            data={uniqueValues.equipmentType}
          />
        );
      case "Industrial Equipment":
        return (
          <MultiSelect
            title="Industrial Equipment"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  industrialEquipment: newValue.industrialEquipment || newValue,
                };
              });
            }}
            errors={errors["Industrial Equipment"]}
            setErrors={setErrors}
            field="industrialEquipment"
            data={uniqueValues.industrialEquipment}
          />
        );
      case "Quantity Consumed":
        return (
          <Range
            title="Quantity Consumed"
            selectedRange={tempFilter?.quantityRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                quantityRange: data,
              }));
            }}
            errors={errors["Quantity Consumed"]}
            setErrors={setErrors}
            placeholderMin="Min"
            placeholderMax="Max"
          />
        );
      case "Hours Used":
        return (
          <Range
            title="Hours Used"
            selectedRange={tempFilter?.hoursRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                hoursRange: data,
              }));
            }}
            errors={errors["Hours Used"]}
            setErrors={setErrors}
            placeholderMax="Max(Hours)"
            placeholderMin="Min(Hours)"
          />
        );
      default:
        return null;
    }
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Stationary Combustion">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Natural Gas"
            url={`/master/getAllIndustrialEquipment?fuelType=Natural Gas`}
            addUrl={`${api}/stationaryCombustion/addNaturalGas`}
            updateUrl={`${api}/stationaryCombustion/updateNaturalGas`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            title={"Natural Gas"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Stationary Combustion"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/stationaryCombustion/deleteNaturalGas`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%" }}
          >
            <Box>
              <TableHeading heading={"Natural Gas Combustion"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData:
                            el.fieldName === "consumptionPeriod"
                              ? getMonthName(item[el.fieldName]?.month) +
                                " " +
                                item[el.fieldName]?.year
                              : el.fieldName === "quantityConsumed"
                              ? truncateNumber(item[el.fieldName].value) +
                                " " +
                                item[el.fieldName].unit
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].industryProcess
                              ? item[el.fieldName].industryProcess
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].name
                              ? item[el.fieldName].name
                              : item[el.fieldName],
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
        {/* {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            fileName={"natural gas"}
            url={"/stationaryCombustion/natural-gas/bulkupload"}
          />
        )} */}
        {bulkUploadModal && (
          <StatioaryBulkUpload
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setFormDataBulkUpload={setFormDataBulkUpload}
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            setBulkUploadTable={setBulkUploadTable}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Natural Gas"}
            url={"/stationaryCombustion/natural-gas/bulkupload"}
            setJsonBulkUpload={setJsonBulkUpload}
          />
        )}
        {bulkUploadTable && (
          <BulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            url={`/master/getAllIndustrialEquipment?fuelType=Natural Gas`}
            // onAddItem={handleAddItem}
            setFormData={setFormDataBulkUpload}
            formData={formDataBulkUpload}
            fuelType="Natural Gas"
            submitUrl={`/master/addIndustrialEquipment`}
            bulkuploadInputData={bulkuploadInputData}
            onConfirm={() => {
              // Handle the bulk upload confirmation here
              setBulkUploadTable(true);
              fetchData();
              // setsnackOpen({
              //   open: true,
              //   message: "Bulk upload completed successfully!",
              //   severity: "success",
              // });
            }}
            jsonBulkUpload={jsonBulkUpload}
            bulkUploadUrl={`/stationaryCombustion/natural-gas/jsonupload`}
            setsnackOpen={setsnackOpen}
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default NaturalGasEquipment;
